import { render, staticRenderFns } from "./AccessGroup.vue?vue&type=template&id=2da83b5a&scoped=true&"
import script from "./AccessGroup.vue?vue&type=script&lang=js&"
export * from "./AccessGroup.vue?vue&type=script&lang=js&"
import style0 from "./AccessGroup.vue?vue&type=style&index=0&id=2da83b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da83b5a",
  null
  
)

export default component.exports